export function isValidBirthDate(birthDate: string): boolean {
  const [day, month, year] = birthDate.split("/");

  try {
    const d = new Date(Number(year), Number(month) - 1, Number(day));

    return (
      d.getFullYear() === Number(year) &&
      d.getMonth() === Number(month) - 1 &&
      d.getDate() === Number(day)
    );
  } catch (err) {
    console.log(err);
    return false;
  }
}
